import React, {useState} from 'react';
import {observer} from "mobx-react";
import Spacer from "./Spacer";
import {Card} from "antd";
import {Container, Draggable} from "react-smooth-dnd";
import {pp} from "../utils";
import {Space} from "antd";
import {HolderOutlined} from "@ant-design/icons";

let applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

let Item = observer(({item, render}) => {
  return <Draggable key={item.id}>
    { render ? render(item) :
      <div style={{width: "225px"}} className="cursor-grab shadow p-2 m-1 bg-white" >
        <Space>
          <HolderOutlined />
          <Spacer l={item.name} r={item.rating} />
        </Space>
      <div className="text-slate-500">{item.captain_name}</div>
    </div> }
  </Draggable>
});

let Group = observer(({onDrop, groups, items, gi, name, itemRender, groupStyle}) => {
  let applyDrop = e => {
    groups[gi] = applyDrag(items, e);
    onDrop(items);
  }
  return <Card bordered={false} size="small" title={`${name} (${items.length})`}>
    <div className="space-y-2">
      <Container
        groupName="col"
        onDrop={applyDrop}
        getChildPayload={index => items[index]}
        dragClass="dnd-card-ghost"
        dropClass="dnd-card-ghost-drop"
        dropPlaceholder={{
          animationDuration: 150,
          showOnTop: true,
          className: 'dnd-drop-preview'
        }}
        dropPlaceholderAnimationDuration={200}
        style={groupStyle || {minHeight: "300px", minWidth: "225px"}}
      >
        {items.map((item, i) => <Item item={item} index={i} key={i} render={itemRender}/>)}
      </Container>
    </div>
  </Card>
})

export default observer(({groups, onDrop, name, nameFunc, groupStyle, itemRender}) => {
  return <div className="flex space-x-4">
    {groups.map((g, gi) => <Group groupStyle={groupStyle} onDrop={onDrop} groups={groups} items={g} gi={gi} key={gi} name={nameFunc ? nameFunc(g, gi) : (name || ("Pool " + (gi+1)))} itemRender={itemRender} />)}
  </div>
});

